module.exports = __webpack_public_path__ + "static/logo-iwc-8f9b826c78686c1a9ab26b9c76cb089d.svg";